export default __webpack_public_path__ + "static/media/14.3129ba45.jpg";